import { render, staticRenderFns } from "./painting-review.vue?vue&type=template&id=680fa897&scoped=true"
import script from "./painting-review.vue?vue&type=script&lang=js"
export * from "./painting-review.vue?vue&type=script&lang=js"
import style0 from "./painting-review.vue?vue&type=style&index=0&id=680fa897&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680fa897",
  null
  
)

export default component.exports